import req from '../req'
// 任务管理

// 获取导购任务列表
export function getSalesperosnTask (params) {
  return req.get('/salesperson/task', params)
}

// 下架导购任务
export function shelvesTask (taskId, params) {
  return req.post('/salesperson/task/handleconfig/' + taskId, params)
}

// 导购任务-统计导购任务
export function getStatistics (taskId, params) {
  return req.get('/salesperson/task/statistics/' + taskId, params)
}

// 获取主任务详情
export function getTaskInfo (taskId, params) {
  return req.get('/salesperson/task/' + taskId, params)
}

// 创建新的导购任务
export function createSalesperosnTask (params) {
  return req.post('/salesperson/task/create', params)
}

// 更新导购任务
export function updateSalesperosnTask (taskId, params) {
  return req.post('/salesperson/task/update/' + taskId, params)
}

// 更新主任务的门店
export function updateTaskStore (taskId, params) {
  return req.post('/salesperson/task/updatetaskstore/' + taskId, params)
}

// 获取子任务列表
export function getSubTaskList (taskId, params) {
  return req.get('/salesperson/subtask/' + taskId, params)
}

// 创建子任务
export function createSubTask (params) {
  return req.post('/salesperson/subtask/create', params)
}

// 更新子任务
export function updateSubTask (taskId, params) {
  return req.post('/salesperson/subtask/update/' + taskId, params)
}

// 下架子任务
export function shelvesSubTask (taskId, params) {
  return req.post('/salesperson/subtask/handleconfig/' + taskId, params)
}
